import { ColumnDef } from '@tanstack/react-table';

import { ChevronDownIcon } from '../../../';
import { TableMeta } from '../table-state-provider';

interface HeaderRendererProps {
  isLoading: boolean;
  toggleAllRowsExpanded: (expanded?: boolean) => void;
  getIsAllRowsExpanded: () => boolean;
}

export const HeaderRenderer = (props: HeaderRendererProps) => {
  const { isLoading, getIsAllRowsExpanded, toggleAllRowsExpanded } = props;
  return (
    <div className={`flex items-center ${isLoading && 'collapse'}`}>
      <button
        onClick={() => {
          toggleAllRowsExpanded();
        }}
      >
        <ChevronDownIcon className={`size-6 ${getIsAllRowsExpanded() ? '' : 'rotate-180'}`} />
      </button>
    </div>
  );
};

interface CellRendererProps {
  isLoading: boolean;
  toggleExpanded: (expanded?: boolean) => void;
  getIsExpanded: () => boolean;
  getIsGrouped: () => boolean;
}

export const CellRenderer = (props: CellRendererProps) => {
  const { getIsExpanded, isLoading, toggleExpanded, getIsGrouped } = props;
  return getIsGrouped() ? (
    <div className={`flex items-center ${isLoading && 'collapse'} size-6 `}>
      <button
        onClick={() => {
          toggleExpanded();
        }}
      >
        <ChevronDownIcon className={`size-6 ${getIsExpanded() ? '' : 'rotate-180'}`} />
      </button>
    </div>
  ) : (
    <div className="w-full"></div>
  );
};

export const expandColumnConfig = <T,>(): ColumnDef<T> => {
  return {
    id: 'expand',
    size: 58,
    enableHiding: false,
    enableSorting: false,
    enablePinning: false,
    header: ({ table }) => {
      return (
        <HeaderRenderer
          getIsAllRowsExpanded={table.getIsAllRowsExpanded}
          isLoading={(table.options.meta as TableMeta).isLoading}
          toggleAllRowsExpanded={table.toggleAllRowsExpanded}
        />
      );
    },
    cell: ({ row, table }) => {
      return (
        <CellRenderer
          getIsExpanded={row.getIsExpanded}
          getIsGrouped={row.getIsGrouped}
          isLoading={(table.options.meta as TableMeta).isLoading}
          toggleExpanded={row.toggleExpanded}
        />
      );
    },
  };
};
